import Vue from 'vue'
import VueApollo from 'vue-apollo'
import axios from 'axios'
import VueAxios from 'vue-axios'
import { ApolloClient } from 'apollo-client'
import { createHttpLink } from 'apollo-link-http'
import { InMemoryCache } from 'apollo-cache-inmemory'
import { ApolloLink } from 'apollo-link'
import * as Sentry from "@sentry/browser"
import { Integrations } from "@sentry/tracing"

import router from './router'
import store from './store'
import App from './App';

import {STORAGE_KEY} from './settings/storage';
import {API_BASE_URL} from './settings';


Sentry.init({
  Vue,
  dsn: "https://70047f2053e44cd8b3fbd2eea469201c@o482496.ingest.sentry.io/5569936",
  autoSessionTracking: true,
  integrations: [
    new Integrations.BrowserTracing(),
  ],

  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  // tracesSampleRate: 1.0,
});

Vue.config.productionTip = false;

const httpLink = createHttpLink({
  uri: `${API_BASE_URL}/graphql/`,
});

const authMiddleware = new ApolloLink((operation, forward) => {
  const stored_data = JSON.parse(localStorage.getItem(STORAGE_KEY));
  const authToken = stored_data ? stored_data.user.authToken: null;
  operation.setContext({
    headers: {
      authorization: authToken ? `JWT ${authToken}` : null
    }
  });

  return forward(operation)
});

const cache = new InMemoryCache({
  addTypename: true
});

const apolloClient = new ApolloClient({
  link: authMiddleware.concat(httpLink),
  cache: cache
});

const apolloProvider = new VueApollo({
  defaultClient: apolloClient,
});

Vue.use(VueApollo);
Vue.use(VueAxios, axios);

new Vue({
  router,
  store,
  apolloProvider,
  render: h => h(App)
}).$mount('#app');
